import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function bridgeClient(token) {
  return axios.create({
    baseURL: API_BASE,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
}

function unwrap(response) {
  const body = response?.data;
  if (body?.success === false) {
    const err = new Error(body.message || 'Request failed');
    err.code = body.code;
    err.parts = body.parts;
    err.status = response.status;
    throw err;
  }
  return body?.data ?? body;
}

async function request(promise) {
  try {
    const res = await promise;
    return unwrap(res);
  } catch (e) {
    const body = e.response?.data;
    const err = new Error(body?.message || e.message || 'Request failed');
    err.code = body?.code;
    err.parts = body?.parts;
    err.status = e.response?.status;
    throw err;
  }
}

/** Map customer-facing tier labels back to internal A/B/C for API */
export const TIER_TO_OPTION = {
  Budget: 'A',
  Value: 'B',
  Premium: 'C',
};

export const OPTION_TO_TIER = {
  A: 'Budget',
  B: 'Value',
  C: 'Premium',
};

export const bridgeService = {
  getJobCard: async (token) =>
    request(axios.get(`${API_BASE}/bridge/jobcard/${encodeURIComponent(token)}`)),

  approveParts: async (token, { jobCardId, choices }) => {
    const client = bridgeClient(token);
    return request(client.post('/bridge/approve-parts', { jobCardId, choices }));
  },

  initiatePayment: async (token, idempotencyKey) => {
    const client = bridgeClient(token);
    return request(client.post('/bridge/payment/parts', { idempotencyKey }));
  },

  getPaymentSummary: async (token) => {
    const client = bridgeClient(token);
    return request(client.get('/bridge/payment/summary'));
  },

  verifyPayment: async (token, razorpayPayload) => {
    const client = bridgeClient(token);
    return request(client.post('/payment/verify', razorpayPayload));
  },
};

export default bridgeService;
